// removed by extract-text-webpack-plugin
module.exports = {"button":"-qjgj","list":"_1TJRV","keyword":"_1-oY8","keywordClickable":"_1_4E1 _1-oY8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/KeywordList.css
// module id = 804
// module chunks = 0